import { useSelector } from 'react-redux';
import Button from '@navi/web-ui/lib/primitives/Button/Button';
import { RootState } from '@cp/src/store';
import StatusBanner from './FooterStatus';
import { FooterProps, CallingAgentAuditDetails } from '../../interface';
import { Roles } from '../../../auth/constants/AuthConstants';

const Footer = ({ handleSubmit, isSubmitDisabled }: FooterProps) => {
  const auditDetails = useSelector(
    (state: RootState) => state.callAudit?.callingAgentAuditDetails
  ) as CallingAgentAuditDetails | null;

  const userRoles = useSelector((state: RootState) => state?.common?.userData?.roles);
  const isQcAgent = userRoles?.includes(Roles.ROLE_PX_AUDIT_AGENT);
  const isTeamLead = userRoles?.includes(Roles.ROLE_PX_AUDIT_TEAM_LEAD);

  const auditStatus = auditDetails?.auditStatus || '';
  const showAuditStatus = isTeamLead || isQcAgent;

  return (
    <>
      {showAuditStatus ? <StatusBanner status={auditStatus} /> : null}

      <div className="w-full bg-[var(--bg-primary)] border-0 border-t-[1px] border-[var(--greyscale-light)]">
        <div className="p-3">
          <Button
            className="w-full"
            onClick={handleSubmit}
            variant="primary"
            disabled={isSubmitDisabled}
          >
            Submit feedback
          </Button>
        </div>
      </div>
    </>
  );
};

export default Footer;
